// 通用业务

import userapi from '@/api/userapi';
import raysserveapi from '@/api/raysserveapi';
import { message } from 'antd';

export function getPhoneAreaList() {
  return new Promise((resolve, reject) => {
    const key = 'phoneAreaList_RMwOnOhh';
    const arr = localStorage.getItem(key);
    if(Array.isArray(arr)) {
      resolve(arr);
    } else {
      userapi.listPhoneArea().then(data => {
        if(!Array.isArray(data)) {
          reject(new Error('获取手机区号列表失败'));
          return;
        }
        const list = data.map(item => {
          return {
            ...item,
            label: `${item.name} ${item.phoneAreaCode}`,
            value: `${item.name} ${item.phoneAreaCode}`
          };
        });
        localStorage.setItem(key, JSON.stringify(list));
        resolve(list);
      }).catch(err => {
        reject(err);
      });
    }
  });
}

export function formatParamsForListenAndCompouning(params) {
  const punctuationRegex = /^[，。！？；：“”‘’（）【】《》.,!?;:'"()\[\]<>]*$/;
  function removePunctuationOnlyItems(arr) {  // 过滤不带标签 speakerType 4，5，6
    // 中英文标点符号正则表达式

    return arr.filter(item => {
      // 检查text是否存在且不是空字符串
      if(!item.text || item.text.trim() === '') {
        return false;
      }

      // 如果text只包含标点符号或空白字符，则过滤掉
      return !punctuationRegex.test(item.text.trim());
    });
  }
  const paramsTemp = removePunctuationOnlyItems(params);
  if(!paramsTemp?.length) {
    message.error('请输入中文汉字或英文字母');
    return Promise.reject();
  }
  return raysserveapi.getFormatWordList(paramsTemp).then(res => {
    return new Promise((resolve, reject) => {
      res && res.forEach((item) => {
        if(!item.ext) {
          delete item.ext;
        }
        if(item.text) {
          let filterEmptyDiv = item?.text?.replace(/<div[^>]*><\/div>/g, ''); // 过滤空div标签
          let textTemp = filterEmptyDiv.replace(/&amp;/g, '<![CDATA[&]]>'); //后端转不了&amp; 全部替换成<![CDATA[&]]>

          item.text = textTemp;
        }
      });
      resolve(res);
    });
  });
}

